<template>
  <div>
    <div class="content_box">
      <el-row :span="24">
        <el-col :span="24" style="display: flex;flex-direction: row">
          <el-card v-for="item in countData" :key="item.name" class="countData" :body-style="{display:'flex',padding:0}" >
            <i :class="`el-icon-${item.icon}`" :style="{backgroundColor:item.color,color:'#fff' }"></i>
            <div>
              <p class="value">￥{{item.value}}</p>
              <p class="name">{{item.name}}</p>
            </div>
          </el-card>
        </el-col>
<!--        <el-col :span="8" class="leftPart">-->
<!--          <el-card class="box-card" shadow="always">-->
<!--            <div class="user-info">-->
<!--              <img src="../assets/upload/person_header.png" alt="">-->
<!--              <div>-->
<!--                <p class="user-name">{{ userName }}</p>-->
<!--                <p class="user-identity"></p>-->
<!--              </div>-->
<!--            </div>-->
<!--          </el-card>-->
<!--          <el-card  shadow="always" style="margin-top: 10px;">-->
<!--             <h4>店铺提醒</h4>-->
<!--            <p>-->
<!--              <label @click="goChangeHub">改装轮毂</label>-->
<!--              <label></label>-->
<!--            </p>-->

<!--          </el-card>-->
<!--        </el-col>-->
<!--        <el-col :span="16" class="rightPart">-->
<!--          <el-card class="zhexian" ref="echarts1">-->
<!--            折线图部分-->
<!--          </el-card>-->
<!--          <div class="smallpics">-->
<!--            <el-card class="pic zhuzhuang" >-->
<!--              柱状图-->
<!--            </el-card>-->
<!--            <el-card class="pic">-->
<!--              扇形图-->
<!--            </el-card>-->
<!--          </div>-->
<!--        </el-col>-->
      </el-row>
    </div>
  </div>
</template>
<script>
  import * as echarts from 'echarts'
  export default {
    name: "WelcomeView",
    data() {
      return {
        userName:sessionStorage.getItem('creator_name'),
        tableData: [
          {
            name: '项目合同',
            todayBuy: 0,
            monthBuy: 0,
            totalBuy: 0
          },
          {
            name: '日常合同',
            todayBuy: 0,
            monthBuy: 0,
            totalBuy: 0
          },
          {
            name: '资产合同',
            todayBuy: 0,
            monthBuy: 0,
            totalBuy: 0
          },
          {
            name: '服务合同',
            todayBuy: 0,
            monthBuy: 0,
            totalBuy: 0
          },
          {
            name: '其他入库',
            todayBuy: 0,
            monthBuy: 0,
            totalBuy: 0
          },
          {
            name: '其他协议',
            todayBuy: 0,
            monthBuy: 0,
            totalBuy: 0
          }
        ],
        dataLabel: {
          name:"合同类型",
          todayBuy:"今日增加",
          monthBuy:"本月增加",
          totalBuy:"总数量",
        },
        countData: [

          {
            name: '数量',
            value: 0,
            icon: "s-goods",
            color: "#5ab1ef",
          },
          {
            name: "会员",
            value: 0,
            icon: "success",
            color: "#2ec7c9",
          },
          {
            name: "员工",
            value: 0,
            icon: "star-on",
            color: "#ffb980",
          },
          {
            name: "合同",
            value: 0,
            icon: "s-goods",
            color: "#ef705a",
          },
        ],
      }
    },
    mounted() {
      //基于准备好的dom，初始化echarts实例
      const echarts1= echarts.init(document.getElementsByClassName('zhexian').item(0))
      //指定图表的配置项和数据
      var echarts1Option={
        title: {
          text: '数据统计分析'
        },
        tooltip: {},
        legend: {
          data: ['个数']
        },
        xAxis: {
          data: ['数量', '数量', '数量', '入库数', '金额', '金额']
        },
        yAxis: {},
        series: [
          {
            name: '个数',
            type: 'line',
            data: [5, 20, 36, 10, 10, 20]
          }
        ]
      }
      echarts1.setOption(echarts1Option)
      // // 接下来我们制作柱状图
      // const echarts2 = echarts.init(document.getElementsByClassName('zhuzhuang').item(0))
      // const {userData} = data.data
      // let echarts2Option = {}
      // echarts2Option.xAxis = {
      // 	type: 'category',
      // 	data: userData.map(item => item['date'] )
      // }
      // echarts2Option.yAxis = {};
      // echarts2Option.series = {
      // 	data: userData.map(item => item['active'] ),
      // 	type: 'bar',
      // 	showBackground: true,
      // 	backgroundStyle: {
      // 		color: 'rgba(250, 220, 95, 0.8)'
      // 	}
      // }
      //
      // // 使用刚指定的配置项和数据显示图表。
      // echarts2.setOption(echarts2Option)
    },
    methods: {
      goChangeHub(){
        this.$router.push('/changeHub')
      },
    }
  }
</script>
<style scoped lang="less">
  .leftPart{padding-right: 10px;}
  img {
    height: 150px;
    margin-right: 40px;
    border-radius: 50%;
  }
  .user-info {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #ccc;
    .user-name {
      font-size: 16px;
      margin: 0;
      margin-bottom: 10px;
    }
    .user-identity {
      margin: 0;
    }
  }
  span {
    margin-left: 60px;
  }

  p {
    margin: 0;
  }

  .countData {
    width: 31%;
    margin-right: 5px;
    margin-bottom: 14px;
    display: flex;flex-direction: row;justify-content: flex-start;align-items: center;
    i {
      height: 80px;
      width: 80px;
      font-size: 20px;
      line-height: 80px;
      text-align: center;
    }
    .value {
      font-size: 20px;
      margin-bottom: 10px;

    }
    .name {
      text-align: center;
      color: #999;
      font-size: 14px;
    }
    div {
      display: flex;
      flex-direction: column;
      justify-content:center;
      margin-left: 15px;
    }
  }
  .rightPart {
    display: flex;
    flex-wrap:wrap;
  }


  .el-col {
    padding: 10px;
  }
  .zhexian {
    width: 100%;
    height: 250px;
  }
  .smallpics {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 10px;
    .pic {
      height: 195px;
      width: 48%;
    }
  }
</style>
